import { IVec2 } from "@base/math/Vec2";

export function isPointInPolygon(polygon: IVec2[], point: IVec2): boolean {
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    if (
      (polygon[i].y > point.y) !== (polygon[j].y > point.y) &&
      (point.x < (polygon[j].x - polygon[i].x) * (point.y - polygon[i].y) / (polygon[j].y - polygon[i].y) + polygon[i].x)
    ) {
      inside = !inside;
    }
  }
  return inside;
}